import React, { Component } from 'react';
import $ from 'jquery';
import { Link,browserHistory } from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Reset extends Component {
	constructor(props){
		super(props);

		this.state={
			mobile: localStorage.mobile_number,
			mobile_number: localStorage.mobile_number,
			password: '',
			confirm_password: '',
			err: false,
			err_pass: '',
			err_c_pass: '',
			mismatch: '',
			err_msg:'',
		};
		this.handleSubmit=this.handleSubmit.bind(this);
		this.passwordChange=this.passwordChange.bind(this);
		// this.confirmPassChange=this.confirmPassChange.bind(this);
		// this.validate=this.validate.bind(this);
		// this.onPassChange=this.onPassChange.bind(this);
	}
	// onPassChange(event){
	// 	// alert(event.target.value);
	// 	this.validation(event.target.value);
	// }
	// // validation(value){
	// 	// console.log(value);
	// 	var valid_pass = this.validPass();
	// 	// var valid_c_pass = this.validCPass();
	// 	return ( valid_pass );
		
	// 	// if(value.length < 4 ){
	// 	// 	alert("Password must be more than 4 characters");
	// 	// }
	// 	// if(value=== '') {
	// 	// 	return "Required";
	// 	// }

	// }

	// handlePasswordInput(value){
	// 	this.setState({
	// 		password: value
	// 	});
	// 	var self= this;
	// 	window.setTimout(function(){
	// 		if(self.state.confirmPassword && self.state.confirmPassword.length) {
	// 			            this.validate(self.state.confirmPassword);
	// 		}
	// 	})

	// }
	//  handleConfirmPasswordInput(value) {
 //        this.setState({
 //            confirmPassword: value
 //        })
 //    }
 //    isConfirmedPassword(value) {
 //       // console.log(value,this.state.password,value===this.state.password);
 //        return (value === this.state.password)

 //    }
	handleSubmit(event)
	{
		event.preventDefault();
		var x = this.refs.confirmPassword.value;
		var flag=1;
		if(x.length <= 3)
		{
			flag=0;
			this.setState({
				err:true,
				err_msg:'* password is minimum 4 characters',
			})
		}
		else if(x==='')
		{
			flag=0;
			this.setState({
				err:true,
				err_msg:'* enter password',
			});
		}
		else
		{
			flag=1;
		}
		var mobile = '';
		if(localStorage.mobile_number){
			mobile = localStorage.mobile_number;
		}
		else if(localStorage.mobile){
			mobile = localStorage.mobile;
		}
		var data1 = {from: 'mobile_web',password: this.refs.confirmPassword.value,mobile: mobile,device_id:localStorage.getItem('push_device_id')}
		var data2 =JSON.stringify(data1)
		if(flag===1)
		{
			$.ajax({
				method: 'POST',
				url: baseUrl+'resetpass',
				data: {req:data2},
				dataType: 'json',
				success: function(data){
					// console.log(data);
					if(data.status==="success"){
						localStorage.setItem('token',data.result[0].token);
	          			localStorage.setItem('user_id',data.result[0].id);
						 browserHistory.push('/');
						 // window.location.reload();					
					}
				}
			})	
		}
		else
		{
			this.setState({
				err:true,
			});
		}
		
	}

	passwordChange(event){
		this.setState({
			password: event.target.value,
			err:false,
		});
	}
	// confirmPassChange(event){
		
	// 	this.setState({
	// 		confirm_password: event.target.value,
	// 	},function(){
	// 		if(this.state.password !== this.state.confirm_password){
	// 				this.setState({
	// 					err: true,
	// 					mismatch: "Password Mismatch",
	// 				})				
	// 		}
	// 		else{
	// 			this.setState({
	// 				err: false,
	// 			})
	// 		}
	// 	});
	// 	// this.validate(event);
	// }
	
	render(){
		document.title ="AquaDeals Reset - You find,buy best deals by register with us";
        document.getElementsByTagName("META")[2].content="You find,buy best deals by register with us";
	return (
		<div className="mob_deals mob_reset_page">
			<section className="tot_pag">
    			<div className="page_hdr">
	        		<div className="container">
	              		<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Reset Password</h5>
	              		<a href="/" className="home_newicon"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home"/></a>
	        		</div>
	    		</div>
				<div className="clr">&nbsp;</div>    
				<section className="pag_cntnt">
        			<div className="container">
            	 		<div className="" style={{overflow: 'hidden'}}>
				    		<div className="enquire_form signup_blk proced_blk">
							    <div className="newlogin_logo"><img src={baseAssets+'icons/web_icons/cc_footer_icon.png'} alt="" /></div>
							    <form className="mtrl_elmnts" onSubmit={this.handleSubmit}>
							        <div className="col-md-12" style={{marginLeft:'30px',marginRight:'30px'}} >
							        	<div className="group">      
								          	<img src={baseAssets+'icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
								          	<input type="text" value={this.state.mobile_number} required placeholder="Mobile Number" />
								          	<span className="highlight"></span>
								          	<span className="bar"></span>
								        </div>
				        				<div className="group">      
								        	<img src={baseAssets+'icons/web_icons/lock.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
								        	<input type="password" placeholder="New Password" ref="confirmPassword" onChange={this.passwordChange} required/>
								          	<span className="highlight"></span>
								          	<span className="bar"></span>
								          	{this.state.err ? <span style={{color:'red',fontSize:'12px'}}>{this.state.err_msg}</span>: ''}
								        </div>
								        <div className="clr">&nbsp;</div>
        								<div className=""><button onSubmit={this.handleSubmit} action="submit" className="btn mob_reset_btn">RESET <i className="glyphicon glyphicon-menu-right"></i></button></div>
        							</div>
    							</form>
    						</div>
    					</div>
    				</div>
  				</section>
			</section>
		</div>
	);
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Auth/reset.js
 **/